import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type {
	LWApiPublicAccountUserListParamsRawI,
	LWApiPublicAccountUserListResultRawI,
} from '@liquidweb-dev/club-sauce/public/account/user/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const ACCOUNT_USER_LIST_QUERY_KEY = '/account/user/list';

const useAccountUserList = (
	params: LWApiPublicAccountUserListParamsRawI,
	options?: UseQueryOptions<LWApiPublicAccountUserListResultRawI, ApiErrorI>,
) =>
	useQuery({
		queryKey: [ACCOUNT_USER_LIST_QUERY_KEY, params],
		queryFn: () => api.account.user.apiRaw.list(params),
		...options,
	});

export default useAccountUserList;
